<div class="footer d-flex justify-content-between border-0">
  <button type="button" id="okButton" class="btn btn-success fw-bold" (click)="emitResponse(responseType.Accepted)">
    OK
  </button>
  <button type="button" id="cancelButton" class="btn btn-danger fw-bold" (click)="emitResponse(responseType.Cancelled)">
    Cancel
  </button>
</div>